<template>
    <div class="input radio-button-group">
        <label v-if="label">{{ label }}</label>
        <br v-if="!inline" />
        <mt-radio-button
            style="padding: 8px"
            v-for="option in options"
            :key="option.id || option.text"
            :label="option.text"
            :value="option.value"
            :disabled="disabled"
            v-model="internalBinding"
        />
        <div class="input-error" v-for="(errorMessage, index) in errorMessages" :key="index">{{ errorMessage }}</div>
    </div>
</template>
<script>
export default {
    name: 'RadioButton',
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: {
            required: false,
        },
        options: {
            required: true,
            type: Array,
        },
        label: {
            type: String,
            required: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorMessage: {
            type: [String, Array],
            required: false,
            default: '',
        },
    },
    computed: {
        internalBinding: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            },
        },
        errorMessages() {
            if (!this.errorMessage) {
                return []
            }

            return Array.isArray(this.errorMessage) ? this.errorMessage : [this.errorMessage]
        },
    },
}
</script>
